import { Entity } from '../entity.js';
import { EFFECT_TYPES } from '../combat/statusEffects.js';
import { clampGroundCast, isInAbilityCircle, isWithinAbilityRange } from '../combat/abilityArea.js';

export function createNami(id = 'nami-1', team = 'blue', x = 300, y = 1300) {
  const nami = new Entity({
    id,
    type: 'champion',
    team,
    x,
    y,
    maxHp: 548,
    maxMp: 475,
    ad: 51,
    ap: 0,
    armor: 26,
    mr: 30,
    ms: 335,
    attackRange: 550,
    attackSpeed: 0.644,
    name: 'Nami',
    radius: 20
  });
  nami.tidecallerBuff = false;
  return nami;
}

export function castNamiQ(caster, x, y, entities = []) {
  if (!caster || caster.isDead || caster.mp < 60) return false;
  caster.mp -= 60;
  const aim = clampGroundCast(caster, x, y, 850);
  const damage = 55 + (caster.ap || 0) * 0.5;
  for (const e of entities) {
    if (!e || e.isDead || e.team === caster.team) continue;
    if (!isInAbilityCircle(e, aim.x, aim.y, 200, caster)) continue;
    e.takeDamage(damage, caster, 'magic');
    e.statusManager?.addEffect?.(EFFECT_TYPES.STUN, 1.5, 1);
  }
  return true;
}

export function castNamiW(caster, entities = [], selectedTarget = null) {
  if (!caster || caster.isDead || caster.mp < 70) return false;
  caster.mp -= 70;
  const healAmt = 55 + (caster.ap || 0) * 0.3;
  const dmg = 50 + (caster.ap || 0) * 0.45;
  const focus = selectedTarget && !selectedTarget.isDead ? selectedTarget : null;
  if (focus && focus.team === caster.team) {
    if (!isWithinAbilityRange(caster, focus, 725, caster)) {
      caster.mp += 70;
      return false;
    }
    focus.hp = Math.min(focus.maxHp, focus.hp + healAmt);
  } else if (focus && focus.team !== caster.team) {
    if (!isWithinAbilityRange(caster, focus, 725, caster)) {
      caster.mp += 70;
      return false;
    }
    focus.takeDamage(dmg, caster, 'magic');
  } else {
    caster.hp = Math.min(caster.maxHp, caster.hp + healAmt);
  }
  for (const e of entities) {
    if (!e || e.isDead || e === focus || e === caster) continue;
    if (e.team !== caster.team) continue;
    if (!isInAbilityCircle(e, (focus || caster).x, (focus || caster).y, 800, caster)) continue;
    e.hp = Math.min(e.maxHp, e.hp + healAmt * 0.7);
    break;
  }
  return true;
}

export function castNamiE(caster, selectedTarget = null) {
  if (!caster || caster.isDead || caster.mp < 55) return false;
  const target = selectedTarget && !selectedTarget.isDead ? selectedTarget : caster;
  if (target.team !== caster.team) return false;
  if (target !== caster && !isWithinAbilityRange(caster, target, 800, caster)) {
    return false;
  }
  caster.mp -= 55;
  target.tidecallerBuff = true;
  target.ms += 40;
  return true;
}

export function castNamiR(caster, targetX, targetY, projectiles, gameTime) {
  if (!caster || caster.isDead || caster.mp < 100) return false;
  caster.mp -= 100;
  const angle = Math.atan2(targetY - caster.y, targetX - caster.x);
  const damage = 120 + (caster.ap || 0) * 0.6;
  projectiles.push({
    id: `nami-r-${caster.id}-${gameTime}`,
    casterId: caster.id,
    team: caster.team,
    x: caster.x,
    y: caster.y,
    vx: Math.cos(angle) * 850,
    vy: Math.sin(angle) * 850,
    range: 2750,
    traveled: 0,
    damage,
    damageType: 'magic',
    radius: 250,
    onHitStatus: EFFECT_TYPES.KNOCKUP
  });
  return true;
}
